import { apiCall } from "./authServices";

export const addMainBanner = async ({payload}) => {
  try {
    const endpoint = "api/dashboard/main-banner";
    const response = await apiCall({
      endpoint: endpoint,
      payload: payload,
      method: "POST"
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getMainBanner = async () => {
  try {
    const endpoint = "api/dashboard/get-main-banner";
    const response = await apiCall({
      endpoint: endpoint,
      method: "GET"
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteMainBanner = async (bannerId) => {
  try {
    const endpoint = `api/dashboard/delete-main-banner/${bannerId}`;
    const response = await apiCall({
      endpoint: endpoint,
      method: "DELETE"
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const addBottomBanner = async ({payload}) => {
  try {
    const endpoint = "api/dashboard/bottom-banner";
    const response = await apiCall({
      endpoint: endpoint,
      payload: payload,
      method: "POST"
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getBottomBanner = async () => {
  try {
    const endpoint = "api/dashboard/get-bottom-banner";
    const response = await apiCall({
      endpoint: endpoint,
      method: "GET"
    });
    return response;
  } catch (error) {
    throw error;
  }
};
